if (process.env.REACT_APP_ENABLE_MEMOIZEE_DEVTOOLS) {
  const memProfile = require("memoizee/profile");

  // Putting some debugging tools for memoizee on the window

  (window as any).logFabricMemoizeeProfile = () => {
    console.log(memProfile.log());
  };

  (window as any).fabricMemoizeeStatistics = memProfile.statistics;
}

// Make TS happy.
export const a = null;
